import { render, staticRenderFns } from "./FaqSnapshots.vue?vue&type=template&id=6c8bec0e&scoped=true&"
import script from "./FaqSnapshots.vue?vue&type=script&lang=js&"
export * from "./FaqSnapshots.vue?vue&type=script&lang=js&"
import style0 from "./FaqSnapshots.vue?vue&type=style&index=0&id=6c8bec0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8bec0e",
  null
  
)

export default component.exports